import { wrappingInputRule } from 'prosemirror-inputrules';
import type { ParseSpec } from 'prosemirror-markdown';
import type { NodeSpec, Node as ProsemirrorNode } from 'prosemirror-model';
import toggleList from '../commands/toggleList';
import type { MarkdownSerializerState } from '../lib/markdown/serializer';
import type { NodeOptions } from './Node';
import Node from './Node';

export default class BulletList extends Node {
	get name() {
		return 'bullet_list';
	}

	get schema(): NodeSpec {
		return {
			content: 'list_item+',
			group: 'block',
			parseDOM: [{ tag: 'ul' }],
			toDOM: () => ['ul', 0],
		};
	}

	commands({ type, schema }: NodeOptions) {
		return () => toggleList(type, schema.nodes.list_item);
	}

	keys({ type, schema }: NodeOptions) {
		return {
			'Shift-Ctrl-8': toggleList(type, schema.nodes.list_item),
		};
	}

	inputRules({ type }: NodeOptions) {
		return [wrappingInputRule(/^\s*([-+*])\s$/, type)];
	}

	toMarkdown(state: MarkdownSerializerState, node: ProsemirrorNode) {
		state.renderList(node, '  ', () => `${node.attrs.bullet || '*'} `);
	}

	parseMarkdown(): ParseSpec {
		return { block: 'bullet_list' };
	}
}
